import * as React from "react"
const BB8 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    transform="rotate(-45)"
    viewBox="0 0 64 64"
    {...props}
  >
    <path
      fill="#1d1d1b"
      d="M18.79 26.51a9.91 9.91 0 0 1-.58-9.75c2.62-5.25 9.33-7.55 9.33-7.55a10.75 10.75 0 0 1-.42-2.5c.17-.25 2.88-1 3.13-.66a13.39 13.39 0 0 1 .46 2.75l1.29.12a8.66 8.66 0 0 1 1.12.21s-.62-5.87-.5-6 4.09-.58 4.21-.33.17 7.5.17 7.5 3.66 1.37 5.5 6.33.5 6.79.5 6.79L41.62 25s7.38 4.16 9 8.58S53 45.09 50 50.38s-8.5 11.67-20 10.88-16.17-9.55-17.54-14.21-.3-15.92 6.33-20.54z"
    />
    <path
      fill="#e6e4da"
      d="M19.87 24.46a9.5 9.5 0 0 1 .92-8.29c2.67-3.91 6-5.5 10.87-5.41s7.63 2.7 8.63 5.54 1.5 6 1.25 6.21-.88-.17-2.13-.71a26.58 26.58 0 0 0-2.7-1s1.95-1.71.29-3.5-4.63-.38-5 .87.83 2.59.83 2.59a14.93 14.93 0 0 0-7.54 1 32.64 32.64 0 0 0-5.42 2.7z"
    />
    <path
      fill="#fff"
      d="M34.29 17.63a1.63 1.63 0 0 1 2.17 1.79c-.34 1.09-2.34.88-2.67.29a1.35 1.35 0 0 1 .5-2.08z"
    />
    <path
      fill="#1d1d1b"
      d="M28.12 12.05c2-.48 4 .79 4.21 2.54a3.38 3.38 0 0 1-5 3c-3.04-1.59-1.17-5.08.79-5.54zM34.9 18.27a.68.68 0 1 1-.18 1.19c-.64-.34-.24-1.09.18-1.19z"
    />
    <path
      fill="#ffe19b"
      d="M28.55 8.84s-.41-1.22-.25-1.31 1.09-.5 1.16-.28.34 1.59.18 1.59zM34 3.84c.12-.12 1.75-.38 1.75-.09s.18 6.09 0 6a13.59 13.59 0 0 1-1.44-.41c-.04-.13-.42-5.44-.31-5.5z"
    />
    <g fill="#1d1d1b">
      <path d="M23.21 18a12.4 12.4 0 0 1-.21-2.75c.18-.13.5-.35.53-.1s.56 2.56.5 2.78-.82.07-.82.07zM20 20.87a8.59 8.59 0 0 1 2-1.5 4.31 4.31 0 0 1 1.93-.53 8.1 8.1 0 0 1 .75 2.62 4.77 4.77 0 0 1-.9.32s-.53-1.94-.75-1.85a25.26 25.26 0 0 0-2.32 1.35 2.7 2.7 0 0 1-.56.37s-.15-.75-.15-.78zM34.05 13.06a12.29 12.29 0 0 1 2.37.31c1.19.25 1.6.53 1.66.69s.19.47.06.56-1.37-.37-2.28-.53-1.44-.06-1.53-.16-.41-.84-.28-.87zM38.64 17.9a5.37 5.37 0 0 1 1.85.47c.09.19.28.81.15.81a8.71 8.71 0 0 1-1.84-.43c-.16-.16-.16-.85-.16-.85zM38.92 19.53a5.37 5.37 0 0 1 1.85.47c.09.18.28.81.15.81a8.17 8.17 0 0 1-1.84-.44c-.16-.16-.16-.84-.16-.84z" />
    </g>
    <path
      fill="#fff"
      d="M37.77 25.62A11.77 11.77 0 0 1 41.71 27c2.15 1.15 2.59 2.18 2.59 2.18a6 6 0 0 1-4.19-.9 5.37 5.37 0 0 1-2.34-2.66z"
    />
    <path
      fill="#fab900"
      d="M34.8 25.21a7.58 7.58 0 0 1 1.41.25 7.18 7.18 0 0 0 4 4.13 11.55 11.55 0 0 0 5.46.78c.25.09 1.85 1.66 1.66 1.72s-4.87 1.19-8.28-1-4.41-4.78-4.25-5.88z"
    />
    <path
      fill="#e6e4da"
      d="M32.52 24.9c.18 0 .25 5.53 5.69 7.6a22 22 0 0 0 10.15 1.18 9.18 9.18 0 0 1 .88 2.78c-.1.16-1.5.16-1.57.94s.47 1.53.85 1.5a6 6 0 0 0 1.15-.34l.16 1.22a8.36 8.36 0 0 0-7.62 3.28 31.56 31.56 0 0 0-4.63 9 13.05 13.05 0 0 0-.28 1.47s-1-1.69-1.25-1.6-.75.19-.59.41l2 2.88a11.22 11.22 0 0 0 .21 1.46c.13.41.5 1.32.5 1.32s-3.09-4.66-3.31-4.57-.59.44-.56.6 3.22 4.28 3.06 4.4a4 4 0 0 1-.72.35s-2.64-3.32-2.81-3.32-.53.38-.5.47A35.23 35.23 0 0 1 35.86 59c-.19.06-1.59.12-1.59.12a19.41 19.41 0 0 0-2-2c-.19 0-.66.53-.56.69s1.4 1.31 1.22 1.41a13.56 13.56 0 0 1-1.85.06s-.19-.78-.47-.81a2.82 2.82 0 0 0-.75.06s0 .72-.09.72a11.42 11.42 0 0 1-5.09-1.07 9.36 9.36 0 0 1-3.07-2.12s1.57-.75 1.19-1.59-1-1.19-1.56-1.07-1 1.72-1 1.72a12.23 12.23 0 0 1-3-2.94 10.74 10.74 0 0 1-1.69-2.81 1.31 1.31 0 0 0 .75-.4 2.16 2.16 0 0 0 .5-.72A9.5 9.5 0 0 0 22.36 52c4 1.18 7.31.87 10.19-1.16s5.66-7.06 4.62-11.5a10.41 10.41 0 0 0-7.37-7.5 15.18 15.18 0 0 0-9.5 1.84 18.32 18.32 0 0 0-3.84 4.13 9.1 9.1 0 0 1-1.47-.5c-.1-.09.78-5.28 2.9-7.38s7.11-6.5 14.63-5.03z"
    />
    <path
      fill="#e6e4da"
      d="M14.21 39.43a.53.53 0 0 0 .46.47 1.84 1.84 0 0 0 1-.25 10.22 10.22 0 0 0-.43 4 19.79 19.79 0 0 0 .9 3.35 1.09 1.09 0 0 0-.84 0 2.6 2.6 0 0 0-.66.63 16.46 16.46 0 0 1-.78-4.09c0-1.76.03-3.54.35-4.11z"
    />
    <path
      fill="#fab900"
      d="M25.86 33.31c4-.55 8.69.84 9.44 7a9.27 9.27 0 0 1-6.59 10.28c-3 .88-8.6.06-10.54-4.31a9.47 9.47 0 0 1 7.69-12.97z"
    />
    <path
      fill="#1d1d1b"
      d="M24.67 37.06c0-.1-.56-.94-.21-1.25a5.1 5.1 0 0 1 4.9-.35c2.66 1 2.85 2.69 2.75 2.79s-1.06 1.25-1.06 1.25l.72 1.21s2-.25 2.09 0a6.66 6.66 0 0 1-1.09 5.31c-1.72 2.22-3.31 2.56-3.44 2.44s-.91-1.79-.91-1.79l-1.12.47a16.93 16.93 0 0 1 .41 1.86 3.85 3.85 0 0 1-3.91.65 7.82 7.82 0 0 1-4-3.81c-.13-.44 1.19-1 1.19-1.16a9.35 9.35 0 0 0-.32-1.06s-1.5.25-1.53.1a4.52 4.52 0 0 1 .66-4.5c1.69-2.47 3.25-2.88 3.34-2.72a8.69 8.69 0 0 0 .47 1.09c.1.09 1.06-.53 1.06-.53z"
    />
    <path
      fill="#fff"
      d="M22.36 37.81s.66 1.06.85 1.09a10.33 10.33 0 0 0 2.62-1 5.94 5.94 0 0 0-.19-1.65 3.56 3.56 0 0 1 3.07 0c1.75.78 1.87 1.56 1.87 1.56s-1 1.37-.91 1.5 1.5 2.41 1.5 2.41a12.37 12.37 0 0 1 1.82.12 5.39 5.39 0 0 1-1 3.22 5.82 5.82 0 0 1-2.13 2.09s-.78-1.5-1-1.5-2.59.75-2.59 1.1.28 2.06.28 2.06a3.31 3.31 0 0 1-3.55-.88c-1.85-1.68-2.1-1.9-1.85-2s1.19-.75 1.19-1a15.85 15.85 0 0 0-.62-2.12c-.07-.1-1.85 0-1.88-.1a8.67 8.67 0 0 1 .8-2.71c.53-.94 1.25-2 1.72-2.19z"
    />
    <path
      fill="#1d1d1b"
      d="M25.36 39.71a2.66 2.66 0 0 1 4 2.66c-.09 2.63-4.66 3.5-5.25 1s.38-3.19 1.25-3.66z"
    />
    <path
      fill="#fab900"
      d="M25.88 40.71a1.55 1.55 0 0 1 2.32 1.55c-.05 1.54-2.72 2.05-3.07.57s.24-1.83.75-2.12zM21.58 54.4c.2-.1.44.28.25.47s-.25.22-.41.13-.03-.5.16-.6z"
    />
    <path
      fill="#1d1d1b"
      d="M29.24 54.71a1.38 1.38 0 0 1 2.25.47 1.34 1.34 0 0 1-1.78 1.75c-1.41-.5-.91-1.62-.47-2.22z"
    />
    <path
      fill="#fab900"
      d="M29.81 55.29a.55.55 0 0 1 .89.19.53.53 0 0 1-.71.69c-.55-.17-.36-.64-.18-.88z"
    />
    <path
      fill="#1d1d1b"
      d="M38.74 37.53A1.37 1.37 0 0 1 41 38a1.34 1.34 0 0 1-1.78 1.75c-1.42-.5-.92-1.63-.48-2.22zM21 29.34a1.38 1.38 0 0 1 2.25.47 1.34 1.34 0 0 1-1.78 1.75c-1.39-.5-.89-1.63-.47-2.22zM30.42 28.74a1.06 1.06 0 0 1 1.74.37 1 1 0 0 1-1.38 1.35c-1.09-.39-.7-1.26-.36-1.72zM38.26 33.9a1.07 1.07 0 0 1 1.75.36 1 1 0 0 1-1.38 1.36c-1.09-.39-.71-1.26-.37-1.72zM36.26 48.12a1.07 1.07 0 0 1 1.75.36 1 1 0 0 1-1.38 1.36c-1.09-.39-.71-1.26-.37-1.72z"
    />
    <path
      fill="#fab900"
      d="M39.31 38.1a.55.55 0 0 1 .89.19.53.53 0 0 1-.71.69c-.55-.19-.36-.64-.18-.88z"
    />
    <path
      fill="#1d1d1b"
      d="M43.89 37.84c.77-.34 1.56.5 1.29 1.45s-1.53 1.71-2.18.6.25-1.77.89-2.05z"
    />
    <path
      fill="#fab900"
      d="M44 38.59c.3-.14.62.2.51.57s-.6.67-.88.24.08-.7.37-.81z"
    />
    <path
      fill="#1d1d1b"
      d="M47.06 34.72a1.07 1.07 0 0 1-.33 1.91c-.91.38-2.27-.14-1.86-1.35s1.57-.88 2.19-.56z"
    />
    <path
      fill="#fab900"
      d="M46.52 35.24c.29.15.23.6-.13.76s-.9-.06-.74-.54.62-.35.87-.22zM40.24 57a10.69 10.69 0 0 1 .62-8.68 14.22 14.22 0 0 1 6.66-6.63 15.33 15.33 0 0 1 2.37-.28l-.06 1.16a6.46 6.46 0 0 0-5.19 3.25A14.69 14.69 0 0 0 42 52.9c0 1 .5 3.06.31 3.19a12.92 12.92 0 0 1-2.07.91z"
    />
    <path
      fill="#fff"
      d="M43.61 55a9.11 9.11 0 0 1 1.06-7.1A14.12 14.12 0 0 1 48 44.12a5.36 5.36 0 0 1 1.72-.62 19.13 19.13 0 0 1-.44 3.21 4.73 4.73 0 0 1-.6 1.54s-1.68-1.94-1.9-1.88-.6.5-.47.69 2 1.62 1.91 1.84-.41 1.06-.5 1-1.57-1.62-1.79-1.59-.68.41-.56.59 2.13 1.63 1.88 2l-.38.53a13.26 13.26 0 0 0-1.78-1.72 1.3 1.3 0 0 0-.41.85c.07.15 1.57 1.53 1.47 1.65s-.22.47-.34.44-1.09-1.06-1.22-1-.47.75-.31.91.87.66.87.81A11.9 11.9 0 0 1 43.61 55zM28.43 13.06a2.2 2.2 0 0 1 2.77 1.67 2.22 2.22 0 0 1-3.31 2c-1.98-1.07-.74-3.37.54-3.67z"
    />
  </svg>
)
export default BB8
